import React, { useState } from "react"
import BannerHeader from '../../molecules/banner-header/banner-header'
import forma from "../../../assets/images/capacidades/forma.svg"
import forma1 from "../../../assets/images/home/forma1.png"
import OutOfTheBox from "../../atoms/out-of-the-box/out-of-the-box"
import ModalCapacidades from "../../molecules/modal-capacidades/modal-capacidades"
import ModalCapacidadesInfo from "../../molecules/capacidades-modal-info/capacidades-modal-info"
import logoAgentes from "../../../assets/images/capacidades/agentesLogo.svg"
import logoLogros from "../../../assets/images/capacidades/logrosLogo.svg"
import infoAgentes from "../../../constants/infoCapacidades"
import infoLogros from "../../../constants/infoLogros"

import "./capacidades-internas.scss"

const CapacidadesInternas = (props) => {

    const { isMobile, resultQueryCapacidades } = props

    const [openModalAgentes, setOpenModalAgentes] = useState(false)
    const [openModalLogros, setOpenModalLogros] = useState(false)

    const informationFilter = resultQueryCapacidades

    return (
        <>
            { openModalAgentes || openModalLogros ? null :
                <div className="f-inngenio-capacidades">
                    <BannerHeader bannerInformation={informationFilter} isMobile={isMobile} />

                    <div className="f-inngenio-capacidades__infoPrincipal">

                        <h2 className="f-inngenio-capacidades__infoPrincipal-title">{informationFilter[0].tituloPrincipal}</h2>


                        <div className="f-inngenio-capacidades__infoPrincipal-content">
                            <div className="f-inngenio-capacidades__infoPrincipal-image size-img">
                                <img className="f-inngenio-capacidades__infoPrincipal-image-Agentes" src={informationFilter[0].imagenPrincipal[0].file.url} alt={informationFilter[0].imagenPrincipal[0].file.fileName} />
                            </div>
                            <div className="f-inngenio-capacidades__infoPrincipal-info">
                                <p>{informationFilter[0].descripcionPrincipal.json.content[0].content[0].value}</p>
                                <button onClick={() => { setOpenModalAgentes(true) }}>{informationFilter[0].ctaNombrePrincipal}</button>
                            </div>
                            <img className="f-inngenio-capacidades__infoPrincipal-content_forma" src={forma} alt="forma1" />
                        </div>

                        <div className="f-inngenio-capacidades__infoPrincipal-content content-mobile">
                            <div className="f-inngenio-capacidades__infoPrincipal-info">
                                <h2>{informationFilter[0].tituloSecundario}</h2>
                                <p>{informationFilter[0].descripcionSecundaria.json.content[0].content[0].value}</p>
                                <a className="f-inngenio-capacidades__infoPrincipal-info-link" href={informationFilter[0].ctaRedireccionSecundaria} target="_blank">{informationFilter[0].ctaNombreSecundario}</a>
                            </div>
                            <div className="f-inngenio-capacidades__infoPrincipal-image">
                                <img src={informationFilter[0].imagenSecundaria[0].file.url} alt={informationFilter[0].imagenSecundaria[0].file.fileName} />
                            </div>
                        </div>

                        <div className="f-inngenio-capacidades__infoPrincipal-content">
                            <div className="f-inngenio-capacidades__infoPrincipal-image size-img">
                                <img className="f-inngenio-capacidades__infoPrincipal-image-Logros" src={informationFilter[0].imagenTerciaria[0].file.url} alt={informationFilter[0].imagenTerciaria[0].file.fileName} />
                            </div>
                            <div className="f-inngenio-capacidades__infoPrincipal-info">
                                <p>{informationFilter[0].descripcinTerciaria.json.content[0].content[0].value}</p>
                                <button onClick={() => { setOpenModalLogros(true) }}>{informationFilter[0].ctaNombreTerciario}</button>
                            </div>
                        </div>

                    </div>

                    <OutOfTheBox informationFilter={informationFilter} />

                    <img className="f-inngenio-capacidades__forma" src={forma1} alt="forma" />

                </div>
            }

            {openModalAgentes ?
                <ModalCapacidades informationFilter={informationFilter} isMobile={isMobile} setOpenModalAgentes={setOpenModalAgentes}>
                    <ModalCapacidadesInfo 
                        logo={logoAgentes}
                        infoModal={infoAgentes}
                        isMobile={isMobile}
                    />
                </ModalCapacidades> : null}

            {openModalLogros ?
                <ModalCapacidades informationFilter={informationFilter} isMobile={isMobile} setOpenModalLogros={setOpenModalLogros}>
                     <ModalCapacidadesInfo 
                        logo={logoLogros}
                        infoModal={infoLogros}
                        isLogros={true}
                        isMobile={isMobile}
                    />
                </ModalCapacidades> : null}
        </>
    )
}

export default CapacidadesInternas
